/**
this snippet listens to the participantFormReady Event which is thrown when the participantForm Modal is opened.
It then searches for judge.me reviews on the same product page and if it finds reviews greater than 4* it shows
them inside the overlay

**/

    document.addEventListener("participantFormReady", () => {

        const productType = document.getElementById("participantData__DataStore").getAttribute("data-producttype");
        const containerElement = document.querySelector(".participantData__Container");
    
    
        let wrapperEl = document.querySelector(".participantData__TestimonialWrapper");
        const reviewCards = document.querySelectorAll(".Pdp-Ratings-Reviews-Card");
    
        if (reviewCards.length > 0) { // Korrektur: `size` existiert nicht, stattdessen `length`
            let reviewCardWrapper = document.createElement("div");
            reviewCardWrapper.classList.add("participantData__JudgeMeReviews__Wrapper");
    
            reviewCards.forEach((card) => {
                let ratingScore = parseInt(card.querySelector(".text-body-l-bold").innerText);
                if (ratingScore >= 4) {

                    card.classList.add("partDataTestimonial")
                    reviewCardWrapper.appendChild(card);
                }
            });
    
            // **Überprüfung, ob reviewCardWrapper Inhalte hat**
            if (reviewCardWrapper.children.length > 0) {
    
            
                
    
                containerElement.appendChild(reviewCardWrapper);
                
                let headline = document.createElement("h2");
                headline.classList.add("heading");
                headline.innerText = "Lass dich von unseren Kund*innen überzeugen: ";
    
                containerElement.insertBefore(headline, reviewCardWrapper);
    
    
    
            } else {
                
                
            }
        }
    });
    

